import React from "react"
import EditorialMethodPage from "../../templates/hotels/EditorialMethodPage"

const Page = () => <EditorialMethodPage locale="fr" />

export default Page
